// plugins/snackbar.js
export default defineNuxtPlugin({
  parallel: true,
  setup(nuxtApp) {
    const snackbar = useSnackbar();
    nuxtApp.provide('snackbar', snackbar);
  }
});
